export const USER_ACTION_TYPES = {
    SET_CURRENT_USER: "SET_CURRENT_USER",
    CHECK_USER_SESSION: "CHECK_USER_SESSION",
    GOOGLE_SIGN_IN_START: "GOOGLE_SIGN_IN_START",
    EMAIL_SIGN_IN_START: "EMAIL_SIGN_IN_START",
    SIGN_UP_START: "SIGN_UP_START",
    SIGN_UP_SUCCESS: "SIGN_UP_SUCCESS",
    SIGN_UP_FAILED: "SIGN_UP_FAILED ",
    SIGN_IN_SUCCESS: "SIGN_IN_SUCCESS",
    SIGN_IN_FAILED: "SIGN_IN_FAILED",
    SIGN_OUT_START: "SIGN_OUT_START",
    SIGN_OUT_SUCCESS: "SIGN_OUT_SUCCESS",
    SIGN_OUT_FAILED: "SIGN_OUT_FAILED",
    SET_PROFILE_DROPDOWN_OPEN: "SET_PROFILE_DROPDOWN_OPEN",
    SET_POP_UP_OPEN: "SET_POP_UP_OPEN"
}